import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-financeiro',
  template: `
  <router-outlet></router-outlet>
`,
})
export class FinanceiroComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
